import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ValueType } from '../overview-tiles/types';

@Component({
  selector: 'app-arrow-icon',
  imports: [CommonModule],
  templateUrl: './arrow-icon.component.html',
  styleUrl: './arrow-icon.component.scss'
})
export class ArrowIconComponent {
  @Input() direction?: 'up' | 'down';
  @Input() color?: ValueType;
  @Input() size: 'small' | 'big' = 'big';
}
